import { styled } from '@mui/material/styles'

export const STEP_MIN_WIDTH = 104
export const STEP_MAX_WIDTH = 200

export const List = styled('ol')({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  margin: 0,
  padding: 0,
  listStyle: 'none',
})
